if(!customElements.get('product-form')){
    class ProductForm extends HTMLElement {
        constructor(){
            super();
            
            this.init();
        }

        init(){
            this.form = this.querySelector('form');
            this.cart = document.querySelector('custom-cart-popup');
            this.btnCart = this.querySelector('.btn-cart');
            this.productCard = this.closest('.product-card');

            if(this.closest('.shopify-section')){
                this.popupVariant = this.closest('.shopify-section').querySelector('variant-popup');
            }

            if(this.btnCart){
                this.btnCart.addEventListener('click', this.submitToCart.bind(this));
            }

            this.addEventListener('keydown', (event) => {
                if(event.key === 'Escape'){
                    this.closeVariantPopup();
                }
            });
        }
        refresh(){
            this.init();
        }

        submitToCart(e){
            var item = e.currentTarget;
            if(item.dataset.variant == 'true'){ // new popup exists
                this.openVariantPopup();
                return;
            }

            if(item.getAttribute('data-disabled') == 'true'){
                return;
            }

            this.item = item;

            const formData = new FormData(this.form);
            
            this.item.setAttribute('data-disabled', 'true');

            //config
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            fetch('/cart/add', config)
            .then(res => res.json())
            .then(res => {
                if(res.status){
                    // sold out message
                    this.btnCart.closest('product-form').classList.add('d-none');
                    this.btnCart.remove();

                    // add soldout message
                    if(this.closest('.product-card, .product-info').querySelector('.price')){
                        let soldoutBadge = document.createElement('span');
                        soldoutBadge.innerHTML = window.smallText.soldOutText? window.smallText.soldOutText : "SOLD OUT";
                        soldoutBadge.classList.add('badge');
                        soldoutBadge.classList.add('badge--sold-out');

                        this.closest('.product-card').querySelector('.price').appendChild(soldoutBadge);
                        this.closest('.product-card').querySelector('.price').classList.add('price--sold-out');
                        return;
                    }
                }

                if(this.cart){
                    this.cart.renderContent(res);
                }else{
                    this.getCartSize();
                }
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                this.btnCart.setAttribute('data-disabled', 'false');
            })
        }

        getCartSize(){
            fetch(`${window.shopUrl || ''}/cart.js`, { headers: { 'Accept': 'application/json' } })
            .then(res => res.json())
            .then(data => {
                const count = data.item_count;
                document.querySelectorAll('.cart-count, .hof-header__cart-count, [data-cart-count]').forEach(el => {
                    el.textContent = count;
                    el.hidden = count === 0;
                });
            })
            .catch(e => { console.error(e); })
        }

        submitVariantToCart(e){
            e.preventDefault();

            if(this.btnCart.getAttribute('data-disabled') == 'true') return;

            const formData = new FormData(this.form);
            this.btnCart.setAttribute('data-disabled', 'true');

            // add form inputs
            if(this.popupVariant.querySelectorAll('[data-product-input]').length > 0){
                this.popupVariant.querySelectorAll('[data-product-input]').forEach(item => {
                    formData.append(item.getAttribute('name'), item.value);
                })
            }

            // config
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            // remove sold out message
            if(this.popupVariantContent.querySelector('.badge--sold-out')){
                this.popupVariantContent.querySelector('.price').classList.remove('price--sold-out');
                this.popupVariantContent.querySelector('.badge--sold-out').remove();
            }

            fetch('/cart/add', config)
            .then(res => res.json())
            .then(res => {
                if(res.status){
                    if(this.buyButtons) this.buyButtons.setAttribute('data-hidden', 'true');

                    // add sold out message
                    let soldoutBadge = document.createElement('span');
                    soldoutBadge.innerHTML = window.smallText.soldOutText? window.smallText.soldOutText : "SOLD OUT";
                    soldoutBadge.classList.add('badge');
                    soldoutBadge.classList.add('badge--sold-out');

                    this.popupVariantContent.querySelector('.price').appendChild(soldoutBadge);
                    this.popupVariantContent.querySelector('.price').classList.add('price--sold-out');
                }

                if(res.description){
                    // error
                    if(this.popupVariantContent.querySelector('#product-form .cart-422-error')){
                        this.popupVariantContent.querySelector('#product-form .cart-422-error').remove();
                    }
                    var errorElem = document.createElement('div');
                    errorElem.className = 'cart-422-error py-3';
                    errorElem.textContent = `${res.description}`;
                    this.popupVariantContent.querySelector('#product-form').appendChild(errorElem);
                }else{
                    // render item in cart
                    if(this.cart){
                        this.cart.renderContent(res);
                    }else{
                        this.getCartSize();
                    }
                }

            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                this.btnCart.setAttribute('data-disabled', 'false');

                // close variant popup if no error
                if(this.popupVariantContent.querySelectorAll('.cart-422-error').length == 0){
                    this.closeVariantPopup();
                }
            })
        }

        openVariantPopup(){
            if(this.form == null){
                this.init();
            }

            this.previouslyFocusedElement = document.activeElement;

            this.popupVariant.setAttribute('data-hidden', 'false');
            this.popupVariant.setAttribute('data-product-id', `${this.dataset.productId}`);

            // body not to be scrollable
            document.querySelector('html').style.overflow = 'hidden';
            
            this.popupVariantContent = this.popupVariant.querySelector('.variant__product');
            this.popupVariant.querySelectorAll('[data-type="close"]').forEach(item => {
                item.addEventListener('click', this.closeVariantPopup.bind(this));
            })
            this.popupVariantLoadingBar = this.popupVariant.querySelector('#variant-popup__loading-state');
            this.popupVariantLoadingBar.setAttribute('data-hidden', 'false');
            
            this.popupVariant.addEventListener('click', e => {
                if(e.target === this.popupVariant) this.closeVariantPopup();
            })
            this.popupVariant.addEventListener('keyup', e => {
                if(e.code?.toUpperCase() === 'ESCAPE') this.closeVariantPopup();
            })

            // get variant list from product details page
            var productLink = this.dataset.productLink;
            productLink = productLink.split('?');
            productLink = productLink[0];
            this.productLink = `${productLink}?section_id=product-variant-details`;

            if(this.productCard){
                const swatchSelector = this.productCard.querySelector('.variant-swatch-selector');
                if(swatchSelector){
                    const selectedSwatchVariant = swatchSelector.querySelector('input[type="radio"]:checked');
                    if(selectedSwatchVariant){
                        this.productLink = `${this.productLink}&option_values=${selectedSwatchVariant.dataset.optionValueId}`;
                    }   
                }
            }

            // add option values
            fetch(`${this.productLink}`)
            .then(res => {
                if(!res.ok){
                    var error = new Error(res.status);
                    throw error;
                }

                return res.text();
            })
            .then(text => {
                const productVariantDetails = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-product-variant-details');
                const productMediaElements = productVariantDetails.querySelectorAll('.product-media');

                productMediaElements.forEach(elem => elem.remove());

                const resultsMarkup = productVariantDetails.innerHTML;
                this.popupVariantContent.innerHTML = resultsMarkup;

                const productMediaMarkup = Array.from(productMediaElements).map(element => element.outerHTML).join('');

                if(this.popupVariant.querySelector('.variant-popup__media')){
                    const popupVariantMedia = this.popupVariant.querySelector('.variant-popup__media');
                    popupVariantMedia.innerHTML = productMediaMarkup;

                    // add media control
                    var videoIdx = 0;
                    popupVariantMedia.querySelectorAll('video, iframe').forEach(item => {
                        if(videoIdx == 0){
                            var mediaType = item.nodeName == 'IFRAME'? 'external_video' : 'video';
                            this.startVideo(item, mediaType);
                        }
                        videoIdx++;
                    });

                    this.productMedia = this.popupVariant.querySelector('.product-media');
                    this.productMediaImages = this.popupVariant.querySelectorAll('product-media-image');
                    this.swiperContainer = (this.productMedia)? this.productMedia.querySelector('.swiper-container') : null;
                    this.productModels = this.querySelectorAll('product-model');

                    setTimeout(() => {
                        this.productMedia.setAttribute('data-hidden', 'false');
                    }, 500);

                    this.initSwiperInPopup();
                }

                setTimeout(() => {
                    requestAnimationFrame(() => {
                        if (this.popupVariant && this.popupVariant.scrollTop !== 0) {
                          this.popupVariant.scrollTop = 0;
                        }
                    });
                }, 1);

                // add loading
                this.popupVariantLoadingBar.setAttribute('data-hidden', 'true');

                this.form = this.popupVariantContent.querySelector('#product-form');
                this.cart = document.querySelector('custom-cart-popup');
                this.buyButtons = this.popupVariantContent.querySelector('.product-buy-buttons');
                this.btnCart = this.popupVariantContent.querySelector('.btn-cart');
                if(this.btnCart){
                    if(this.btnCart.dataset.effect === 'wave'){
                        const svgString = `
                        <svg class="editorial" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" width="200px">
                          <defs>
                            <path id="gentle-wave" d="M-160 44c30 0 
                                68-18 88-18s
                                68 18 88 18 
                                68-18 88-18 
                                68 18 88 18
                                v44h-352z"></path>
                          </defs>
                          <g class="parallax">
                            <use xlink:href="#gentle-wave" x="40" y="10" fill="#ffffff"></use>  
                            <use xlink:href="#gentle-wave" x="30" y="10" fill="#ffffff" fill-opacity="0.2"></use>  
                          </g>
                        </svg>`;
                
                        const parser = new DOMParser();
                        const svgElement = parser.parseFromString(svgString, 'image/svg+xml').documentElement;

                        const svgClone = svgElement.cloneNode(true);
                        if(!this.btnCart.querySelector('svg')){
                            this.btnCart.appendChild(svgClone);
                        }

                        this.btnCart.addEventListener("click", function(event){
                            const ripple = document.createElement('span');
                            ripple.classList.add('wave-ripple');
              
                            const rect = this.getBoundingClientRect();
                            const size = Math.max(rect.width, rect.height);
                            const x = event.clientX - rect.left - size / 2;
                            const y = event.clientY - rect.top - size / 2;
              
                            ripple.style.width = ripple.style.height = `${size}px`;
                            ripple.style.left = `${x}px`;
                            ripple.style.top = `${y}px`;
              
                            this.appendChild(ripple);
              
                            ripple.addEventListener('animationend', () => {
                                ripple.remove();
                            });
                        })
                    }
                }

                if(this.innerWrapper){
                    setTimeout(() => {
                        this.innerWrapper.scrollTop = 0;
                    }, 300);
                }

                setTimeout(() => {
                    // hide loading
                    this.popupVariantLoadingBar.setAttribute('data-hidden', 'true');
                }, 500);

                this.form.addEventListener('submit', this.submitVariantToCart.bind(this));

                // focus
                this.popupVariantContent.querySelectorAll('[tabindex]:not([tabindex="-1"])')[0].focus();
            })
            .catch((error) => {
                console.error(error);
            });
        }

        initSwiperInPopup(){
            if(!this.swiperContainer) return;
            var swiperSettings = {
                init: true,
                initialSlide: 0,
                loop: false,
                spaceBetween: 0,
                speed: 500,
                watchOverflow: true,
                observer: true,
                observeSlideChildren: true
            }

            swiperSettings.navigation = {
                nextEl: this.swiperContainer.querySelector('.swiper-button-next'),
                prevEl: this.swiperContainer.querySelector('.swiper-button-prev')
            }

            swiperSettings.pagination = {
                el: this.swiperContainer.querySelector('.swiper-pagination')
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.checkPagination();
            this.getVisibleSlides();

            this.swiper.on("slideChange", e => {
                this.stopAllVideo();
                this.getVisibleSlides();

                // start media
                var currentSlide = this.swiperContainer.querySelector(`.swiper-slide[data-media-idx="${e.realIndex + 1}"]`);
                var mediaType = currentSlide.dataset.mediaType;
                if(mediaType == 'video'){
                    this.startVideo(currentSlide.querySelector('video'), mediaType);
                }else if(mediaType == 'external_video'){
                    this.startVideo(currentSlide.querySelector('iframe'), mediaType);
                }
            });

            this.swiper.on("resize", () => {
                this.checkPagination();
            });
        }

        stopAllVideo(){
            // external video
            var externalVideos = this.swiperContainer.querySelectorAll('iframe');
            externalVideos.forEach(item => {
                // youtube
                if(item.contentWindow)
                    item.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');

                // vimeo
                var vimeoUrl = new URL(item.src);
                if (vimeoUrl.hostname.includes('vimeo.com')) {
                    var vimeoData = {
                        method: 'pause'
                    };
                    item.contentWindow.postMessage(JSON.stringify(vimeoData), vimeoUrl.origin);
                    var seekData = {
                        method: 'setCurrentTime',
                        value: 0
                    };
                    item.contentWindow.postMessage(JSON.stringify(seekData), vimeoUrl.origin);
                }
                
                if(item.closest('.media-wrapper')){
                    const thumbnail = item.closest('.media-wrapper').querySelector('.thumbnail');
                    if(thumbnail){
                        thumbnail.style.opacity = '1';
                        thumbnail.style.transition = 'opacity 0.5s ease-in';
                    }
                }
            });

            // video
            var embedVideos = this.swiperContainer.querySelectorAll('video');
            embedVideos.forEach(item => {
                item.pause();
                item.currentTime = 0;
            });
        }

        checkPagination(){
            var pagination = this.popupVariant.querySelector('.swiper-pagination');
            var btns = {
                prev: this.popupVariant.querySelector('.swiper-button-prev'),
                next: this.popupVariant.querySelector('.swiper-button-next')
            }
            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        closeVariantPopup(){
            this.popupVariant.setAttribute('data-hidden', 'true');
            this.popupVariant.removeAttribute('data-product-id');

            this.popupVariantContent.innerHTML = '';

            this.stopVideo();

            // body not to be scrollable
            document.querySelector('html').style.overflow = 'initial';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        startVideo(elem, mediaType){
            if(mediaType == 'video'){
                elem.play();
            }else if(mediaType == 'external_video'){
                var itemSrc = elem.dataset.src;
                if(elem.getAttribute('src') != ''){
                    if(elem.contentWindow){
                        // youtube
                        elem.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                        elem.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

                        // vimeo
                        var vimeoUrl = new URL(elem.src);
                        if (vimeoUrl.hostname.includes('vimeo.com')) {
                            var vimeoMuteData = {
                                method: 'setVolume',
                                value: 0  // Set volume to 0 (mute)
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoMuteData), "*");

                            var vimeoData = {
                                method: 'play'
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoData), "*");
                        }
                    }
                    return; 
                }

                elem.setAttribute('src', itemSrc);
                elem.onload = function() {
                    if (elem.contentWindow) {
                        // youtube
                        elem.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                        elem.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

                        // vimeo
                        var vimeoUrl = new URL(elem.src);
                        if (vimeoUrl.hostname.includes('vimeo.com')) {
                            var vimeoMuteData = {
                                method: 'setVolume',
                                value: 0  // Set volume to 0 (mute)
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoMuteData), "*");

                            var vimeoData = {
                                method: 'play'
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoData), "*");
                        }
                    }
                };
            }
        }

        stopVideo(){
            var externalVideos = this.popupVariant.querySelectorAll('iframe');
            externalVideos.forEach(item => {

                // youtube
                if(item.contentWindow)
                    item.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');

                // vimeo
                var vimeoUrl = new URL(item.src);
                if (vimeoUrl.hostname.includes('vimeo.com')) {
                    var vimeoData = {
                        method: 'pause'
                    };
                    item.contentWindow.postMessage(JSON.stringify(vimeoData), vimeoUrl.origin);
                    var seekData = {
                        method: 'setCurrentTime',
                        value: 0
                    };
                    item.contentWindow.postMessage(JSON.stringify(seekData), vimeoUrl.origin);
                }
                
            });

            var embedVideos = this.popupVariant.querySelectorAll('video');
            embedVideos.forEach(item => {
                item.removeAttribute('data-active');
                item.pause();
                item.currentTime = 0;
            });
        }
    }
    customElements.define('product-form', ProductForm);
}